"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Mission() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1202" id="the-summertime-standard" className="relative overflow-hidden bg-background text-foreground py-28 md:py-40">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-lg opacity-20 blur-3xl" style={{
      background: "hsl(43 45% 55%)"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute right-20 bottom-10 h-56 w-56 rounded-lg opacity-20 blur-3xl" style={{
      background: "hsl(184 35% 18%)"
    }} />

      <div className="container mx-auto px-5 md:px-8 max-w-[1280px] relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {}
          <div ref={leftRef} className="lg:col-span-7 order-2 lg:order-1 transition-all duration-700 ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(24px)"
        }}>
            {}
            <div className="inline-block mb-8">
              <span className="inline-block font-mono text-xs md:text-sm font-semibold uppercase tracking-[0.16em] px-3 py-1.5 rounded-md text-primary-foreground bg-primary">
                Our Philosophy · Legacy
              </span>
            </div>

            {}
            <h1 className="font-serif font-medium text-foreground tracking-tight leading-[1.1] mb-10" style={{
            fontSize: "clamp(2.5rem, 5.5vw, 4.5rem)"
          }}>
              Investing in homes,{" "}
              <em className="italic font-serif text-secondary">
                building lasting value.
              </em>
            </h1>

            {}
            <div className="space-y-6 text-foreground/90 font-default">
              <p className="text-base md:text-lg leading-[1.6]">
                Summertime Lane Investments was founded on the principle that residential real estate is more than just an asset class—it is the foundation of community. We partner directly with homeowners to provide seamless, transparent solutions, ensuring that every property we acquire is treated with the respect and integrity it deserves.
              </p>

              {}
              <div className="flex items-center gap-3 py-2" aria-hidden="true">
                <span className="inline-block h-px w-12 bg-secondary" />
                <span className="flex-1 border-t border-border" />
                <span className="inline-block h-2 w-2 rounded-sm bg-secondary" />
                <span className="flex-1 border-t border-border" />
                <span className="inline-block h-px w-12 bg-secondary" />
              </div>

              <p className="text-base md:text-lg leading-[1.6]">
                We do not operate as a brokerage. Instead, we focus on long-term stewardship, thoughtful renovation, and responsible management. By building lasting relationships with our partners and investors, we create sustainable value that benefits the entire neighborhood.
              </p>
            </div>

            {}
            <blockquote className="mt-10 pl-5 italic font-serif text-foreground" style={{
            fontSize: "clamp(1.25rem, 1.8vw, 1.5rem)",
            borderLeft: "2px solid hsl(43 45% 55%)",
            lineHeight: "1.4"
          }}>
              "Integrity is the cornerstone of every investment we make, ensuring a brighter future for our communities."
            </blockquote>

            {}
            <div className="mt-10">
              <Link to="/HomePage" className="group inline-flex items-center gap-2 font-default font-medium text-foreground relative">
                <span className="relative border-b-2 border-secondary">
                  Learn about our approach
                </span>
                <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 order-1 lg:order-2 relative">
            {}
            <div className="relative">
              {}
              <div className="relative overflow-hidden transition-transform duration-[800ms] rounded-lg" style={{
              transform: rightVisible ? "scale(1)" : "scale(0.96)",
              transitionTimingFunction: "cubic-bezier(.2,.8,.2,1)",
              opacity: rightVisible ? 1 : 0,
              boxShadow: "0px 8px 24px hsl(184 35% 18% / 0.15)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723050/img/residential_investment_property.png" alt="A beautifully renovated residential property with warm lighting and clean architectural lines" loading="lazy" decoding="async" className="w-full h-[460px] md:h-[560px] object-cover" />
              </div>

              {}
              <div className="absolute -bottom-6 -right-6 z-10 p-6 bg-card border border-border rounded-lg shadow-lg">
                <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-1">Est.</div>
                <div className="font-serif text-3xl font-bold text-secondary">2024</div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Link to="/HomePage">
            <Button size="lg" className="px-8 py-6 font-bold text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-all duration-200">
              Partner with us
            </Button>
          </Link>
          <span className="font-mono text-xs uppercase tracking-[0.16em] text-muted-foreground">
            Responsible Investing
          </span>
        </div>
      </div>
    </section>;
}